(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["activity-nav-row"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var btn = e.target.closest('.activity-nav__row [data-action="toggle-collapsible"]');
    if (!btn) return;

    var row = btn.closest('.activity-nav__row');
    row.querySelectorAll('[data-action="toggle-collapsible"][aria-expanded="true"]').forEach(function (openBtn) {
      if (openBtn !== btn) {
        document.dispatchEvent(new CustomEvent('collapsible:toggle', {
          detail: { id: openBtn.getAttribute('aria-controls') }
        }));
      }
    });

    if (window.matchMedia('(max-width: 999px)').matches) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) {
        var rect = row.getBoundingClientRect();
        panel.style.top = rect.bottom + 'px';
        panel.style.left = rect.left + 'px';
        panel.style.width = rect.width + 'px';
      }
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
